export default "__VITE_ASSET__YbLZoazl__"